import request from '@/router/axios';
export const keyCerInfo = (loanInformationId) => {
  return request({
      url: '/api/blade-loanCredentialManagement/loanCredentialManagement/keyCerInfo',
      method: 'get',
      params: {
        loanInformationId
      }
  })
}

export const loanOutRecordSubmit = (row) => {
  return request({
      url: '/api/blade-loanOutRecord/loanOutRecord/submit',
      method: 'post',
      data: row
  })
}
